import {Endpoints, API} from '../api';

export interface AllocationAccount {
  accountId: string;
  amount: number;
}

export enum AllocationAccountType {
  CI = 'CI',
  FPG = 'FPG',
}

export interface Allocation {
  id: string;
  name: string;
  accountType?: AllocationAccountType;
  accounts: AllocationAccount[];
}

export type AllocationPayload = Omit<Allocation, 'id'>;

export function getAll() {
  return API.get<Allocation[]>(Endpoints.allocations.collection);
}

export function getById(allocationId: string) {
  return API.get<Allocation>(Endpoints.allocations.single, {params: {allocationId}});
}

export function create(newAllocation: AllocationPayload) {
  return API.post<Allocation>(Endpoints.allocations.collection, newAllocation);
}

export function update(allocationId: string, updatedAllocation: AllocationPayload) {
  return API.put<Allocation>(Endpoints.allocations.single, updatedAllocation, {params: {allocationId}});
}

export function remove(allocationId: string) {
  return API.delete(Endpoints.allocations.single, {params: {allocationId}});
}
